module.exports = __webpack_public_path__ + "img/toilet_sit.287056a5.svg";